import React from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Container,
  Button,
  UncontrolledDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledButtonDropdown,
  FormGroup
} from "reactstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

import { MoreHorizontal, Edit2 } from "react-feather";

import BootstrapTable from "react-bootstrap-table-next";

import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

const { SearchBar } = Search;

// import { MinusCircle, PlusCircle } from "react-feather";

const tableData = [
  {
    id: 1,
    name: "Pavan Welihinda",
    // company: "Xoom Software",
    email: "pavan@xoomsoftware.com",
    receivables: "Rs.320,800",
    totalOrders: 4,
    payables: "Rs.320,800",
    createdDate: "2011/04/25"
  },
  {
    id: 2,
    name: "Pavan Welihinda",
    // company: "Xoom Software",
    email: "pavan@xoomsoftware.com",
    receivables: "Rs.320,800",
    totalOrders: 4,
    payables: "Rs.320,800",
    createdDate: "2011/04/25"
  },
  {
    id: 3,
    name: "Pavan Welihinda",
    // company: "Xoom Software",
    email: "pavan@xoomsoftware.com",
    receivables: "Rs.320,800",
    totalOrders: 4,
    payables: "Rs.320,800",
    createdDate: "2011/04/25"
  },
  {
    id: 4,
    name: "Pavan Welihinda",
    // company: "Xoom Software",
    email: "pavan@xoomsoftware.com",
    receivables: "Rs.320,800",
    totalOrders: 4,
    payables: "Rs.320,800",
    createdDate: "2011/04/25"
  },
  {
    id: 5,
    name: "Pavan Welihinda",
    // company: "Xoom Software",
    email: "pavan@xoomsoftware.com",
    receivables: "Rs.320,800",
    totalOrders: 4,
    payables: "Rs.320,800",
    createdDate: "2011/04/25"
  },
  {
    id: 6,
    name: "Pavan Welihinda",
    // company: "Xoom Software",
    email: "pavan@xoomsoftware.com",
    receivables: "Rs.320,800",
    totalOrders: 4,
    payables: "Rs.320,800",
    createdDate: "2011/04/25"
  },
  {
    id: 7,
    name: "Pavan Welihinda",
    // company: "Xoom Software",
    email: "pavan@xoomsoftware.com",
    receivables: "Rs.320,800",
    totalOrders: 4,
    payables: "Rs.320,800",
    createdDate: "2011/04/25"
  }
];

const tableColumns = [
  {
    dataField: "name",
    text: "Name",
    sort: true
  },
  // {
  //   dataField: "company",
  //   text: "Company",
  //   sort: false
  // },
  {
    dataField: "email",
    text: "Email",
    sort: true
  },
  {
    dataField: "totalOrders",
    text: "Total Orders",
    sort: true
  },
  {
    dataField: "payables",
    text: "Money Spent",
    sort: true
  },
  {
    dataField: "status",
    text: "Status",
    formatter: statusFormatter,
    sort: true
  },
  {
    dataField: "createdDate",
    text: "Date Created",
    sort: true
  },
  {
    dataField: "actions",
    text: "Action(s)",
    formatter: actionFormatter,
    sort: false
  }
];

function actionFormatter(cell, row) {
  return (
    <Button
      tag={Link}
      to={{
        pathname: `/Customers/edit/${row.id}`,
        state: {
          customer: row
        }
      }}
      color="outline"
      className="mt-n1"
    >
      <Edit2 className="align-middle ml-1" size={18} />
    </Button>
  );
}
function statusFormatter(cell, row) {
  return <span className="badge badge-success ml-0 mr-1 mb-1">Success</span>;
}

const RowSelectionTable = () => {
  const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    bgColor: "#f8f9fa"
  };
  return (
    <Card>
      <ToolkitProvider
        keyField="name"
        data={tableData}
        columns={tableColumns}
        exportCSV
        search
      >
        {props => (
          <div>
            <CardHeader>
              <div className="card-actions float-right">
                <UncontrolledDropdown>
                  <DropdownToggle tag="a">
                    <MoreHorizontal />
                  </DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem>Mark as Active</DropdownItem>
                    <DropdownItem>Mark as Inactive</DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>

              <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                <SearchBar {...props.searchProps} />
              </FormGroup>
            </CardHeader>

            <CardBody>
              <BootstrapTable
                bootstrap4
                bordered={false}
                keyField="id"
                data={tableData}
                columns={tableColumns}
                selectRow={selectRow}
                pagination={paginationFactory({
                  sizePerPage: 10,
                  sizePerPageList: [5, 10, 25, 50]
                })}
              />
            </CardBody>
          </div>
        )}
      </ToolkitProvider>
    </Card>
  );
};

const Customers = () => (
  <Container fluid className="p-0 container-fluid">
    <Button
      tag={Link}
      to="/customer/new"
      color="primary"
      className="float-right mt-n1"
    >
      <FontAwesomeIcon icon={faPlus} /> New
    </Button>
    <UncontrolledButtonDropdown key={0} className="mr-1 mb-3">
      <DropdownToggle color={"test"}>
        <span className="h3 mb-3">Customers</span>
      </DropdownToggle>
    </UncontrolledButtonDropdown>

    {/* <PaginationTable /> */}
    <RowSelectionTable />
    {/* <ExpandableRowsTable />
    <ExportCSVTable /> */}
  </Container>
);

export default Customers;
